'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionTypes = require('./action-types');

Object.keys(_actionTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _actionTypes[key];
    }
  });
});
var SITE_NAME = exports.SITE_NAME = {
  FULL: '鏡傳媒 Mirror Media',
  SHORT: '鏡傳媒',
  SEPARATOR: ' - '
};

var SITE_META = exports.SITE_META = {
  DESC: '鏡傳媒以台灣為基地，是一跨平台綜合媒體，包含《鏡週刊》以及下設五大分眾內容的《鏡傳媒》網站，刊載時事、財經、人物、國際、文化、娛樂、美食旅遊、精品鐘錶等深入報導及影音內容。我們以「鏡」為名，務求反映事實、時代與人性。',
  URL: 'https://www.mirrormedia.mg/',
  LOGO: 'https://www.mirrormedia.mg/asset/logo.png',
  KEYWORDS: '鏡週刊,鏡傳媒,mirror media,新聞,人物,調查報導,娛樂,美食,旅遊,精品,動漫,網路趨勢,趨勢,國際,兩岸,政治,明星,文學,劇本,新詩,散文,小說'
};

var SOCIAL_LINK = exports.SOCIAL_LINK = {
  SUBSCRIBE: 'https://goo.gl/forms/g2ny8HzAXTAfwH6I2',
  LINE: 'https://line.me/R/ti/p/%40cuk1273e',
  WEIBO: 'http://www.weibo.com/u/6030041924?is_all=1',
  FACEBOOK: 'https://www.facebook.com/mirrormediamg/',
  WECHAT: '#',
  INSTAGRAM: 'https://www.instagram.com/mirror_media/',
  FEED: '/story/rss.xml',
  EMAIL: 'mailto:mirror885@mirrormedia.mg'
};

var LINK_PREFIX = exports.LINK_PREFIX = {
  ARTICLE: '/article/',
  CATEGORY: '/category/',
  SECTION: '/section/',
  TAG: '/tag/',
  TOPIC: '/topic/'
};

var AD_UNIT_PREFIX = exports.AD_UNIT_PREFIX = {
  'news-people': 'np',
  'entertainment': 'ent',
  'foodtravel': 'fnt',
  'hotvideo': 'wat',
  'watch': 'hv'
};

var groupEnum = exports.groupEnum = {
  CATEGORY: 'category',
  TAG: 'tag',
  TOPIC: 'topic'
};
var apiPathEnum = exports.apiPathEnum = {
  CATEGORY: 'postcategories',
  TAG: 'tags',
  TOPIC: 'topics'
};

var authorTypes = exports.authorTypes = {
  writter: '文',
  photographer: '攝影',
  designer: '設計',
  engineer: '工程'
};

var copyrightTypes = exports.copyrightTypes = {
  default: {
    string: 'Copyright © 2015-2016 鏡傳媒',
    link: null,
    image: null
  },
  copyrighted: {
    string: 'Copyright © 2015-2016 鏡傳媒',
    link: null,
    image: null
  },
  creativeCommons: {
    string: '創用CC姓名標示-非商業性-禁止改作授權條款',
    link: 'http://creativecommons.org/licenses/by-nc-nd/3.0/tw/',
    image: 'LOGO_CC'
  }
};

var CHARACTERS_LIMIT = exports.CHARACTERS_LIMIT = {
  TOPIC_DESC: 120,
  BOTTOM_RELATED_DESC: 120
};

var ITEMS_LIMIT = exports.ITEMS_LIMIT = {
  ARTICLE_RELATED: 3
};

var RELATED_ARTICLES = exports.RELATED_ARTICLES = '延伸閱讀';

var CONTINUE_READING = exports.CONTINUE_READING = '繼續閱讀';

var LOAD_MORE_ARTICLES = exports.LOAD_MORE_ARTICLES = '載入更多文章';

var ARTICLE = exports.ARTICLE = 'ARTICLE';

var HOME = exports.HOME = 'HOME';

var CATEGORY = exports.CATEGORY = 'CATEGORY';

var SECTION = exports.SECTION = 'SECTION';

var TAG = exports.TAG = 'TAG';

var SEARCH = exports.SEARCH = 'SEARCH';

var TOPIC = exports.TOPIC = 'TOPIC';

var QUESTIONNAIRE = exports.QUESTIONNAIRE = 'QUESTIONNAIRE';

var basePath = exports.basePath = 'https://www.mirrormedia.mg';

var GAID = exports.GAID = 'UA-83609754-1';

var DFPID = exports.DFPID = '40175602';

var FBPageId = exports.FBPageId = 1855418728011324;

var appId = exports.appId = 962589903815787;

var colors = exports.colors = {
  whiteBg: '#F1F1F1',
  superWhite: '#FFFFFF',
  darkBg: '#08192d'
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/constants/index.js
 ** module id = 16
 ** module chunks = 0
 **/